module.exports = __webpack_public_path__ + "img/youzanLeatherQRCode.7de1c6e5.png";